// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-item[data-v-0997d45d]{padding:8px 16px 16px}.title[data-v-0997d45d]{margin-bottom:8px}.date[data-v-0997d45d],.snippet[data-v-0997d45d]{font-size:14px}.date[data-v-0997d45d]{opacity:.5}", ""]);
// Exports
module.exports = exports;
